import { useTranslation } from 'react-i18next';

import { ErrorMessage, Loading, withValidPermission } from '@Components';
import { useFetchData } from '@CustomHooks';
import { Permission } from '@Models';
import { bopsApi } from '@Network';
import ScheduleWizard from './scheduleWizard';

const ScheduleWizardContainer = () => {
  const { t } = useTranslation();

  const { data: stores, isLoading: isLoadingStores, error: storesError } = useFetchData(bopsApi.getAllStores);
  const { data: products, isLoading: isLoadingProducts, error: productsError } = useFetchData(bopsApi.getProducts);
  const { data: taskTypes, isLoading: isLoadingTaskTypes, error: taskTypesError } = useFetchData(bopsApi.getTaskTypes);
  const {
    data: fieldServiceContracts,
    isLoading: isLoadingContracts,
    error: contractsError,
  } = useFetchData(bopsApi.getFieldServiceContracts);
  const {
    data: fieldServices,
    isLoading: isLoadingFieldServices,
    error: fieldServicesError,
  } = useFetchData(bopsApi.getFieldServices);

  if (isLoadingStores || isLoadingProducts || isLoadingTaskTypes || isLoadingContracts || isLoadingFieldServices) {
    return <Loading title={t('Schedule.Wizard.Title')} />;
  }

  const error = storesError || productsError || taskTypesError || contractsError || fieldServicesError;
  if (error || !stores || !products || !taskTypes || !fieldServiceContracts || !fieldServices) {
    return <ErrorMessage internalMessage={`Unable to load schedule wizard data: ${error}`} />;
  }

  return (
    <ScheduleWizard
      stores={stores}
      products={products}
      taskTypes={taskTypes}
      fieldServiceContracts={fieldServiceContracts}
      fieldServices={fieldServices}
    />
  );
};

export default withValidPermission(ScheduleWizardContainer, Permission.ManageSchedules);
